// export const BACKEND_BASE_URL = 'https://backend.alphamap.giz.berlin'
export const BACKEND_BASE_URL = 'https://backend.alphamap.giz.berlin'
